export { default as ProjectsDetailsSection } from './projects-details-section';
